import { useEffect, useState } from "react";
import { Flex, LoadingIndicator, Text } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";
import * as styles from "./styles_vanilla.css";

// FR-096: one caption line, alternating. No progress bar, percentage or per-question counter —
// the job reports nothing to drive them, so an indeterminate spinner is the only honest treatment.
export const LOADING_CAPTIONS = ["Doing our diligence...", "Taking a look..."];

export const CAPTION_ROTATE_MS = 4000;

export const ExtractionLoadingState = () => {
  const [captionIndex, setCaptionIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(
      () => setCaptionIndex((index) => (index + 1) % LOADING_CAPTIONS.length),
      CAPTION_ROTATE_MS,
    );
    return () => clearInterval(timer);
  }, []);

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={SPACING.MEDIUM}
      className={styles.loadingState}
      data-testid="ddq-structure-loading"
    >
      <LoadingIndicator size="large" />
      <Text variant="regular-md" color={Colors.Neutral600} aria-live="polite">
        {LOADING_CAPTIONS[captionIndex]}
      </Text>
    </Flex>
  );
};
